/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuyMobileNavRefineMenuFilters_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbMobileRefineMenuFilterPrice_itemSearch" | "SbMobileRefineMenuFilterDeliveryOptions_itemSearch">;
    readonly " $refType": "BuyMobileNavRefineMenuFilters_itemSearch";
};
export type BuyMobileNavRefineMenuFilters_itemSearch$data = BuyMobileNavRefineMenuFilters_itemSearch;
export type BuyMobileNavRefineMenuFilters_itemSearch$key = {
    readonly " $data"?: BuyMobileNavRefineMenuFilters_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"BuyMobileNavRefineMenuFilters_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyMobileNavRefineMenuFilters_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "kind": "LinkedField",
      "name": "appliedFilters",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "kind": "LinkedField",
          "name": "values",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterPrice_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDeliveryOptions_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '2f61bc86de3e72efe800889f1af3b393';
export default node;
